module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/kobe_sns_03-02b5b769ede987b8c9078286eb4058cb.jpg";